"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitConversionLoadStandardsInputSchema = exports.UnitConversionCreateInputSchema = exports.UnitConversionSchema = void 0;
const zod_1 = require("zod");
exports.UnitConversionSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    conversionId: zod_1.z.string(),
    fromUnit: zod_1.z.string().min(1),
    toUnit: zod_1.z.string().min(1),
    ingredientCategory: zod_1.z.string().min(1),
    factor: zod_1.z.number().positive(),
    notes: zod_1.z.string().optional(),
    createdAt: zod_1.z.number(),
    updatedAt: zod_1.z.number(),
});
exports.UnitConversionCreateInputSchema = zod_1.z.object({
    fromUnit: zod_1.z.string().min(1),
    toUnit: zod_1.z.string().min(1),
    ingredientCategory: zod_1.z.string().min(1),
    factor: zod_1.z.number().positive(),
    notes: zod_1.z.string().optional(),
});
exports.UnitConversionLoadStandardsInputSchema = zod_1.z.object({
    categories: zod_1.z.array(zod_1.z.enum(['volume', 'weight', 'liquid', 'count'])).min(1),
});
//# sourceMappingURL=unit-conversion.schema.js.map